module.exports = __webpack_public_path__ + "media/bootstrap-icons/cloud-drizzle-3c6eba25.svg";